import React from "react"
import PropTypes from "prop-types"
import { SearchableDropdownButton } from "quorumdesign"
import swalConfigs from "app/static/frontend/swalConfigs"

const propTypes = {
    initialTemplates: PropTypes.array,
    loadTemplate: PropTypes.func.isRequired,
    getTemplates: PropTypes.func.isRequired,
    small: PropTypes.bool,
    variantId: PropTypes.number
}
const defaultProps = {
    initialTemplates: [],
    small: false,
    loadTemplate() {},
    getTemplates() {},
}

class TemplateLoader extends React.Component {
    constructor(props) {
        super(props)
        this.toggleDropdown = this.toggleDropdown.bind(this)
        this.loadTemplate = this.loadTemplate.bind(this)
        this.handleClickOutside = this.handleClickOutside.bind(this)
        // process templates
        this.state = {
            open: false,
            templates: this.props.initialTemplates
        }
    }

    componentDidMount() {
        this._mounted = true
        this.props.getTemplates()
    }

    componentWillUnmount() {
        this._mounted = false
    }

    updateTemplates(newTemplates) {
        if (newTemplates.length === 0 || !this._mounted) {
            return
        }
        this.setState({
            templates: newTemplates
        })
    }

    toggleDropdown() {
        this.setState({ open: !this.state.open })
    }

    handleClickOutside(e) {
        if (e.target && e.target.classList.contains("search-dropdown-input")) {
            return
        }
        if (this.state.open) {
            this.toggleDropdown()
        }
    }

    async loadTemplate(template) {
        const { value } = await qual.fire(swalConfigs.OUTBOX_LOAD_TEMPLATE_ALERT_CONFIG)
        if (value) {
            // we need to duplicate the attachments
            this.props.loadTemplate(template, this.props.variantId)
        }

        this.toggleDropdown()
    }

    render() {
        return (
            <SearchableDropdownButton
                dataCy="beefree-load-templates-button"
                icon="copy"
                iconFamily="far"
                isTiny={this.props.small}
                onClick={this.loadTemplate}
                options={this.state.templates}
                placeholder="Search Templates..."
                text="Load Template"
            />
        )
    }
}

TemplateLoader.propTypes = propTypes
TemplateLoader.defaultProps = defaultProps

export default TemplateLoader
